import { render, staticRenderFns } from "./SponsorsByDwellTime.vue?vue&type=template&id=58765674&"
import script from "./SponsorsByDwellTime.vue?vue&type=script&lang=js&"
export * from "./SponsorsByDwellTime.vue?vue&type=script&lang=js&"
import style0 from "./SponsorsByDwellTime.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports